<template>
	<div class="validation-group" v-bind:class="cssClass">
		<slot></slot>
		<div class="error-element"></div>
	</div>
</template>
<script>
export default {
	name: "Validation",
	props: ['cssClass'],
}
</script>
